import { useTranslation } from "react-i18next";

import styles from "./styles.module.css";
import Heading from "@/components/atoms/Heading";
import { Button, Group } from "@mantine/core";
import React, { useState } from "react";
import WeightReportsTable from "@/components/organisms/WeightReportsTable";
import { DEFAULT_WEIGHT_REPORTS_COLUMN } from "@/components/organisms/WeightReportsTable/const/default";
import Text from "@/components/atoms/Text";
import { UploadWeightReportModal } from "@/components/organisms/UploadWeightReportModal";

export default function MatchWeightReports() {
  const [open, setOpen] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <>
      <title>{`Reviver - ${t("weightReports:weightReports")}`}</title>
      <meta name="description" content="Reviver" />
      <div className={styles.matchWeightReportsRoot}>
        <div className={styles.matchWeightReportsContent}>
          <Group justify={""} align={"flex-end"} mb={24} mt={32}>
            <Heading order={1} styleOrder={4} strong>
              {t("weightReports:weightReports")}
            </Heading>
            <Button unstyled={true} onClick={() => setOpen(!open)} variant={"transparent"} m={0} p={0}>
              <Text size={"sm"} td={"underline"} color={"tertiary"} p={0} m={0}>
                {t("weightReports:uploadWeightReport")}
              </Text>
            </Button>
          </Group>
          <WeightReportsTable visibleColumns={DEFAULT_WEIGHT_REPORTS_COLUMN} actionable={true} />
        </div>
      </div>
      <UploadWeightReportModal open={open} setOpen={setOpen} />
    </>
  );
}
